"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DATE_FORMAT_WITH_TIME = exports.DEFAULT_DATE_FORMAT = exports.DAY_END_TIME = exports.DAY_START_TIME = exports.TIME_FORMAT_WITH_SEPARATOR = exports.TIME_FORMAT = exports.platformDateTimeFormat = exports.platformDateFormat = void 0;
// date format used on server
exports.platformDateFormat = "YYYY-MM-DD";
exports.platformDateTimeFormat = "YYYY-MM-DD HH:mm";
exports.TIME_FORMAT = "HH:mm";
exports.TIME_FORMAT_WITH_SEPARATOR = ", HH:mm";
exports.DAY_START_TIME = "00:00";
exports.DAY_END_TIME = "23:59";
// default date format used on client
exports.DEFAULT_DATE_FORMAT = "MM/dd/yyyy";
exports.DEFAULT_DATE_FORMAT_WITH_TIME = exports.DEFAULT_DATE_FORMAT + exports.TIME_FORMAT_WITH_SEPARATOR;
//# sourceMappingURL=Platform.js.map